import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { InputGroup as InputGroupCore } from '@blueprintjs/core';
import { isInteger, replace } from 'lodash';

const ElementWrapper = styled.div`
  display: flex;
`;

export default class PhoneNumber extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };
  handleOnChange = (event) =>{
    const value = event.target.value
    const number = Number(value)
    if(this.props.onChange && isInteger(number)){
      return this.props.onChange(replace(value, '.',''))
    }
  }

  render() {
    const { label, ...otherProps } = this.props;
    return (
      <ElementWrapper>
        <InputGroupCore {...otherProps}  onChange={this.handleOnChange} />
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/phone-number/index.js